//Clase de la aplicacion BextDocUI
//Autor:Marlon Granda-Fecha:04/23/2019 - Mail:mar_gran2003@yahoo.com.ar
//Empresa:Marlon Granda

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpResponse } from '@angular/common/http';
import { DataTablesModule } from 'angular-datatables'
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MessageBarComponent } from "./components/controls/message-bar/message-bar.component";
import { HtmlComponent } from "./components/controls/html/html.component";
import { environment } from './../environments/environment';
import { from } from 'rxjs';

import * as bootstrap from "bootstrap";
import * as $ from "jquery";

import { NgDragDropModule } from 'ng-drag-drop';

import { FateModule } from 'fate-editor';
import { ContextMenuModule } from 'ngx-contextmenu';
import { QueryBuilderModule } from "angular2-query-builder";
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { AceEditorModule } from 'ng2-ace-editor';
import { AngularSplitModule } from 'angular-split';
import { AngularFileUploaderModule } from "angular-file-uploader";

import { NgxDocViewerModule } from 'ngx-doc-viewer';

//Angular Material
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  MatNativeDateModule,
  MatIconModule,
  MatButtonModule,
  MatTabsModule,
  MatExpansionModule,
  MatStepperModule,
  MatMenuModule,
  MatToolbarModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule
} from '@angular/material';

//ReCaptcha
// import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';


//Rutas
import { AppRoutes } from './app.routes'

//Servicios
import { LoggerService } from './services/logger.service';
import { BaseServiceService } from './services/base-service.service';
import { GeneralComunicationService } from './services/general-comunication.service';
import { WindowService } from './components/window.component/window.service';
import { ModalNotifyComunicationService } from './services/modal-notify-comunication.service';

//Helpers
import { StaticData } from './helpers/static-data'
import { Utilities } from './helpers/utilities';
import { UtilitiesColumns } from './helpers/utilities-columns';

//Directivas
import { MustMatchDirective } from './directives/must-match.directive';
import { AccessibleFormDirective } from './directives/accessible-form.directive';

//Controles
import { ComboBoxComponent } from './components/controls/combo-box/combo-box.component';
import { WindowComponent } from './components/window.component/window.component';
import { CheckBoxComponent } from './components/controls/check-box/check-box.component';
import { TextAreaComponent } from './components/controls/text-area/text-area.component';
import { MultiComboBoxComponent } from './components/controls/multi-combo-box/multi-combo-box.component';
import { DateBoxComponent } from './components/controls/date-box/date-box.component';
import { TextBoxComponent } from './components/controls/text-box/text-box.component';
import { BotonesFormularioCrudComponent } from './components/controls/botones-formulario-crud/botones-formulario-crud.component';
import { MultiCheckDataTableComponent } from './components/controls/multi-check-data-table/multi-check-data-table.component';
import { ThreeStateToggleComponent } from './components/controls/three-state-toggle/three-state-toggle.component';
import { ObservacionesModificacionVersionComponent } from './components/controls/observaciones-modificacion-version/observaciones-modificacion-version.component';
import { BotonesDataTableComponent } from './components/controls/botones-data-table/botones-data-table.component';
import { ConfigPageComponent } from './components/controls/config-page/config-page/config-page.component';
import { ConfigChildPageComponent } from './components/controls/config-page/config-child-page/config-child-page.component';
import { RoleQueryComponent } from './components/controls/config-page/role-query/role-query.component';
import { RoleFilterComponent } from './components/controls/config-page/role-filter/role-filter.component';
import { ConfigControlsPageComponent } from './components/controls/config-page/config-controls-page/config-controls-page.component';
import { MappingFieldComponent } from './components/controls/config-page/mapping-field/mapping-field.component';
import { MappingFieldContainerComponent } from './components/controls/config-page/mapping-field-container/mapping-field-container.component';
import { DynamicControlsComponent } from './components/controls/dynamic-controls/dynamic-controls.component';

import { GeneralComponentForBuilderComponent } from './components/controls/dynamic-templates/general-component-for-builder/general-component-for-builder.component';
import { GeneralComponentForIDEComponent } from './components/dynamic-templates/general-component-for-ide/general-component-for-ide.component';
import { DynamicControlsIDEComponent } from './components/dynamic-templates/dynamic-controls-ide/dynamic-controls-ide.component';



import { DynamicControlsContainerComponent } from './components/dynamic-templates/dynamic-controls-container/dynamic-controls-container.component';
import { DataTableComponent } from './components/controls/data-table/data-table.component';


//Componentes
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderFormComponent } from './components/header-form/header-form.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { JstreeComponent } from './components/jstree/jstree.component';
import { ModalNotifyComponent } from './components/modal-notify/modal-notify.component';
import { ModalLoginComponent } from './components/modal-login/modal-login.component';
import { SwithComponentsComponent } from './components/bussines/swith-components/swith-components.component';

import { RUsuarioComponent } from './components/bussines/rusuario/rusuario.component';


import { LTLogAppComponent } from './components/bussines/ltlog-app/ltlog-app.component';
import { EditorJsonComponent } from './components/controls/editor-json/editor-json.component';
import { EditorAceComponent } from './components/controls/editor-ace/editor-ace.component';
import { LoginComponent } from './components/login/login.component';

import { OrgChartJsComponent } from './components/org-chart/org-chart-js/org-chart-js.component';
import { OrgChartJsConfigComponent } from './components/org-chart/org-chart-js-config/org-chart-js-config.component';
import { AdminPermisosComponent } from './components/admin-permisos/admin-permisos.component';
import { PalabrasClaveComponent } from './components/palabras-clave/palabras-clave.component';
import { FileUploaderComponent } from './components/controls/file-uploader/file-uploader.component';


import { BaseComponentComponent } from './components/base-component/base-component.component';
import { FormDetailsComponent } from './components/controls/form-details/form-details.component';
import { TextBoxRComponent } from './components/controls/text-box-r/text-box-r.component';
import { TextAreaRComponent } from './components/controls/text-area-r/text-area-r.component';
import { CheckBoxRComponent } from './components/controls/check-box-r/check-box-r.component';
import { ComboBoxRComponent } from './components/controls/combo-box-r/combo-box-r.component';
import { MultiComboBoxRComponent } from './components/controls/multi-combo-box-r/multi-combo-box-r.component';
import { GeneralFormComponent } from './components/controls/general-form/general-form.component';
import { DateBoxRComponent } from './components/controls/date-box-r/date-box-r.component';
import { HelperActions } from './helpers/helper-actions';
import { DragAndDropListComponent } from './components/controls/drag-and-drop-list/drag-and-drop-list.component';
import { DragAndDopMetadataComponent } from './components/controls/drag-and-dop-metadata/drag-and-dop-metadata.component';
import { FormMetadataComponent } from './components/dynamic-templates/form-metadata/form-metadata.component';
import { ThreeStateToggleRComponent } from './components/controls/three-state-toggle-r/three-state-toggle-r.component';
import { AdminPermitidosComponent } from './components/admin-permitidos/admin-permitidos.component';

import { DataTableNgForComponent } from './components/controls/data-table-ng-for/data-table-ng-for.component';

import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TopNavbarComponent } from './components/top-navbar/top-navbar.component';
import { MenuItem2Component } from './components/menu-item2/menu-item2.component';

import { HelperImages } from './helpers/helper-images';


import { AuthBaseComponent } from './components/rule-engine/info-project/auth-base/auth-base.component';
import { AuthenticationModeComponent } from './components/rule-engine/info-project/authentication-mode/authentication-mode.component';
import { SessionConfigComponent } from './components/rule-engine/info-project/session-config/session-config.component';
import { UserSettingsModelComponent } from './components/rule-engine/info-project/user-settings-model/user-settings-model.component';


import { HelperRules } from './helpers/helper-rules';

import { ButtonComponent } from './components/controls/button/button.component';


import { LoadWindowComponent } from './components/load-window/load-window.component';

import { DynamicJsonControlsComponent } from './components/controls/dynamic-json-controls/dynamic-json-controls.component';
import { DynamicHtmlComponent } from './components/controls/dynamic-html/dynamic-html.component';
import { ExtendableTableComponent } from './components/controls/extendable-table/extendable-table.component';
import { FormJsonComponent } from './components/controls/form-json/form-json.component';
import { FiltersDataTableComponent } from './components/controls/filters-data-table/filters-data-table.component';


import { KpiEstadoSolicitudComponent } from './components/controls/kpi-estado-solicitud/kpi-estado-solicitud.component';
import { KpiEstadoSolicitudBaseComponent } from './components/controls/kpi-estado-solicitud-base/kpi-estado-solicitud-base.component';
import { KpiEstadoSolicitudContenedorComponent } from './components/controls/kpi-estado-solicitud-contenedor/kpi-estado-solicitud-contenedor.component';
import { ToolTipValidationComponent } from './components/controls/tool-tip-validation/tool-tip-validation.component';
import { DataTableMosaicComponent } from './components/controls/data-table-mosaic/data-table-mosaic.component';
import { DynamicChartsComponent } from './components/controls/dynamic-charts/dynamic-charts.component';


import { InfoPermissionComponent } from './components/controls/permission/info-permission/info-permission.component';
import { PermissionComponent } from './components/controls/permission/permission/permission.component';
import { UtilityRuleEngine } from './helpers/utility-rule-engine';


import { PropertyGridComponent } from './components/dynamic-templates/property-grid/property-grid.component';
import { PropertyGridControlsComponent } from './components/dynamic-templates/property-grid-controls/property-grid-controls.component';
import { PropertyGridColumnComponent } from './components/dynamic-templates/property-grid-column/property-grid-column.component';

import { UserNavComponent } from './components/user-nav/user-nav.component';
import { SwapFormComponent } from './components/controls/swap-form/swap-form.component';
import { DynamicControlsMetadataComponent } from './components/controls/dynamic-controls-metadata/dynamic-controls-metadata.component';


import { FilterPipe } from './pipes/filter.pipe';
import { DocViewerComponent } from './components/controls/doc-viewer/doc-viewer.component';
import { FormDetailsTableComponent } from './components/controls/form-details/form-details-table/form-details-table.component';
import { CommandBarComponent } from './components/controls/command-bar/command-bar.component';
import { ProgressIndicatorComponent } from './components/controls/progress-indicator/progress-indicator.component';
import { AttachmentSelectionComponent } from './components/controls/attachment-selection/attachment-selection.component';
import { ThemeCustomizationComponent } from './components/theme-customization/theme-customization.component';
import { AdminTodoPermisosComponent } from './components/admin-todo-permisos/admin-todo-permisos.component';
import { ConsoleLogComponent } from './components/console-log/console-log.component';
import { ConsoleLogTableComponent } from './components/console-log/console-log-table/console-log-table.component';
import { SpinnerComponent } from './components/controls/spinner/spinner.component';
import { OverlayComponent } from './components/controls/overlay/overlay.component';
import { PropertyGridConfigControlComponent } from './components/dynamic-templates/property-grid-config-control/property-grid-config-control.component';
import { PropertyGridCustomComponentsComponent } from './components/dynamic-templates/property-grid-custom-components/property-grid-custom-components.component';
import { PropertyGridContainersComponent } from './components/dynamic-templates/property-grid-containers/property-grid-containers.component';
import { SolicitudPqrdComponent } from './components/bussines/solicitudes/pqrs/solicitud-pqrd/solicitud-pqrd.component';
import { ExternalPqrsComponent } from './components/bussines/external-pqrs/external-pqrs.component';

import { RPaginaComponent } from './components/bussines/rpagina/rpagina.component';
import { ExternalPqrsContactComponent } from './components/bussines/external-pqrs-contact/external-pqrs-contact.component';
import { ConsultaExternalPqrsComponent } from './components/bussines/consulta-external-pqrs/consulta-external-pqrs.component';
import { HomeExternalPqrsComponent } from './components/bussines/home-external-pqrs/home-external-pqrs.component';
import { FooterPqrsComponent } from './components/bussines/footer-pqrs/footer-pqrs.component';
import { HeaderPqrsComponent } from './components/bussines/header-pqrs/header-pqrs.component';
import { BreadCrumbComponent } from './components/bussines/bread-crumb/bread-crumb.component';
import { AccessBarComponent } from './components/bussines/access-bar/access-bar.component';
import { UserPqrsComponent } from './components/bussines/user-pqrs/user-pqrs.component';
import { RecoveryExternalPqrsPasswordComponent } from './components/bussines/recovery-external-pqrs-password/recovery-external-pqrs-password.component';
import { DocumentValidateExternalPqrsComponent } from './components/bussines/document-validate-external-pqrs/document-validate-external-pqrs.component';
import { ReCaptchaRComponent } from './components/controls/re-captcha-r/re-captcha-r.component';
import { GuiaUsoExternalPqrsComponent } from './components/bussines/guia-uso-external-pqrs/guia-uso-external-pqrs.component';
import { InitPqrsComponent } from './components/bussines/init-pqrs/init-pqrs.component';
import { PrintComponent } from './components/controls/print/print.component';
import { VisibilityControlDirective } from './directives/visibility-control.directive';
import { BestdocFilterPipe } from './pipes/bestdoc-filter.pipe';
// import { OverlayModule } from '@angular/cdk/overlay';
// import { PortalModule } from '@angular/cdk/portal';
// import { ScrollDispatchModule } from '@angular/cdk/scrolling';

declare var WebConfigData;



@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HeaderFormComponent,
    HomeComponent,
    MustMatchDirective,
    VisibilityControlDirective,
    AccessibleFormDirective,
    JstreeComponent,
    ModalNotifyComponent,
    ModalLoginComponent,
    MenuItemComponent,
    ComboBoxComponent,
    WindowComponent,
    CheckBoxComponent,
    TextAreaComponent,
    MultiComboBoxComponent,
    DateBoxComponent,
    TextBoxComponent,
    BotonesFormularioCrudComponent,
    MultiCheckDataTableComponent,
    ThreeStateToggleComponent,
    ObservacionesModificacionVersionComponent,
    BotonesDataTableComponent,
    SwithComponentsComponent,

    ConfigPageComponent,
    ConfigChildPageComponent,
    RoleQueryComponent,
    RoleFilterComponent,
    ConfigControlsPageComponent,
    MappingFieldComponent,
    MappingFieldContainerComponent,
    DynamicControlsComponent,
    DynamicControlsMetadataComponent,
    GeneralComponentForBuilderComponent,
    GeneralComponentForIDEComponent,
    DynamicControlsIDEComponent,
    PropertyGridComponent,
    PropertyGridControlsComponent,

    DynamicControlsContainerComponent,
    DataTableComponent,

    RUsuarioComponent,

    LTLogAppComponent,
    EditorJsonComponent,
    EditorAceComponent,
    LoginComponent,
    OrgChartJsComponent,
    OrgChartJsConfigComponent,
    AdminPermisosComponent,
    PalabrasClaveComponent,
    FileUploaderComponent,

    PropertyGridColumnComponent,

    BaseComponentComponent,
    FormDetailsComponent,
    TextBoxRComponent,
    TextAreaRComponent,
    CheckBoxRComponent,
    ComboBoxRComponent,
    MultiComboBoxRComponent,
    GeneralFormComponent,
    DateBoxRComponent,
    DragAndDropListComponent,
    DragAndDopMetadataComponent,
    FormMetadataComponent,
    ThreeStateToggleRComponent,
    AdminPermitidosComponent,

    DataTableNgForComponent,
    SidebarComponent,
    TopNavbarComponent,
    MenuItem2Component,
    AuthBaseComponent,
    AuthenticationModeComponent,
    SessionConfigComponent,
    UserSettingsModelComponent,
    ButtonComponent,


    LoadWindowComponent,

    InfoPermissionComponent,
    PermissionComponent,


    DynamicJsonControlsComponent,
    DynamicHtmlComponent,
    ExtendableTableComponent,
    FormJsonComponent,
    FiltersDataTableComponent,

    ToolTipValidationComponent,
    KpiEstadoSolicitudComponent,
    KpiEstadoSolicitudContenedorComponent,
    KpiEstadoSolicitudBaseComponent,
    DataTableMosaicComponent,
    DynamicChartsComponent,

    PropertyGridComponent,
    PropertyGridControlsComponent,
    PropertyGridColumnComponent,

    UserNavComponent,
    SwapFormComponent,
    FilterPipe,
    BestdocFilterPipe,
    DocViewerComponent,
    FormDetailsTableComponent,
    CommandBarComponent,
    ProgressIndicatorComponent,
    AttachmentSelectionComponent,
    ThemeCustomizationComponent,
    AdminTodoPermisosComponent,
    ConsoleLogComponent,
    ConsoleLogTableComponent,
    SpinnerComponent,
    OverlayComponent,
    PropertyGridConfigControlComponent,
    PropertyGridCustomComponentsComponent,
    PropertyGridContainersComponent,
    SolicitudPqrdComponent,
    ExternalPqrsComponent,
    MessageBarComponent,
    HtmlComponent,
    RPaginaComponent,
    ExternalPqrsContactComponent,
    ConsultaExternalPqrsComponent,
    HomeExternalPqrsComponent,
    FooterPqrsComponent,
    HeaderPqrsComponent,
    BreadCrumbComponent,
    AccessBarComponent,
    UserPqrsComponent,
    RecoveryExternalPqrsPasswordComponent,
    DocumentValidateExternalPqrsComponent,
    ReCaptchaRComponent,
    GuiaUsoExternalPqrsComponent,
    InitPqrsComponent,
    PrintComponent
  ],
  // exports: [OverlayModule,
  //   PortalModule,
  //   ScrollDispatchModule],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    HttpClientModule,
    AppRoutes,
    BrowserAnimationsModule,
    NgSelectModule,
    MatNativeDateModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatExpansionModule,
    MatStepperModule,
    MatMenuModule,
    MatToolbarModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    DragDropModule,
    FateModule,
    NgDragDropModule.forRoot(),
    ContextMenuModule.forRoot(),
    QueryBuilderModule,
    NgJsonEditorModule,
    AceEditorModule,
    AngularSplitModule.forRoot(),
    AngularFileUploaderModule,
    NgxDocViewerModule,
    // RecaptchaModule,
    // RecaptchaFormsModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    GeneralComunicationService,
    Utilities,
    UtilitiesColumns,
    HelperImages,
    UtilityRuleEngine,
    HelperActions,
    BaseServiceService,
    WindowService,
    ModalNotifyComunicationService,
    LoggerService,
    {
      provide: APP_INITIALIZER,
      useFactory: onAppInit,
      multi: true,
      deps: [HttpClient]
    },
    HelperRules

  ],
  entryComponents: [WindowComponent,
    PropertyGridControlsComponent,
    ObservacionesModificacionVersionComponent,
    JstreeComponent,
    OrgChartJsConfigComponent,
    OrgChartJsComponent,
    DataTableComponent,
    EditorJsonComponent,
    EditorAceComponent,
    DataTableComponent,
    GeneralFormComponent,
    UserSettingsModelComponent,
    DynamicControlsComponent,
    DynamicControlsMetadataComponent,
    InfoPermissionComponent,
    FormMetadataComponent,
    DocViewerComponent,
    AttachmentSelectionComponent,
    ThemeCustomizationComponent,
    ConsoleLogComponent,
    ConsoleLogTableComponent,
    SpinnerComponent

  ],
  bootstrap: [AppComponent]
})
export class AppModule {


}
export function onAppInit(_http: HttpClient): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise((resolve, reject) => {


      setTimeout(() => {
       
        StaticData.UrlServer = environment.APIEndpoint;
        StaticData.AppName = 'BextDocUI';
        StaticData.HostingType = environment.HostingType;


        if (WebConfigData) {
          StaticData.UrlServer = (WebConfigData.APIEndpoint) ? WebConfigData.APIEndpoint : StaticData.UrlServer;
          StaticData.AppName = (WebConfigData.AppName) ? WebConfigData.APIEndpoint : StaticData.AppName;
          StaticData.HostingType = (WebConfigData.HostingType) ? WebConfigData.HostingType : StaticData.HostingType;
          StaticData.LogosBestDoc = (WebConfigData.LogosBestDoc !== undefined) ? WebConfigData.LogosBestDoc : StaticData.LogosBestDoc;
          environment.PathImages = (WebConfigData.PathImages) ? WebConfigData.PathImages : environment.PathImages;
          if (WebConfigData.DynamicLoadResources != null && WebConfigData.DynamicLoadResources != undefined)
            StaticData.DynamicLoadResources = WebConfigData.DynamicLoadResources;
        }
        resolve(null);
      }, 400);
    });
  };
}
